<template>
  <div class="vm-page" :class="{ 'vm-page--embedded': embedded }">
    <div class="vm-layout">
      <VehicleTeamTreeAside
        ref="teamAsideRef"
        @tree-change="onTeamTreeChange"
        @team-select="onTeamTreeSelect"
        @team-clear="clearGroupFilter"
        @changed="handleGroupChanged"
      />
      <div class="vm-main">
        <div class="vm-card">
      <el-form :inline="true" :model="query" class="vm-query" @submit.native.prevent>
        <el-form-item label="车牌号：">
          <el-input v-model="query.vehicleNo" placeholder="请输入车牌号" clearable @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="别名：">
          <el-input v-model="query.aliasName" placeholder="请输入别名" clearable @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="车牌颜色：">
          <el-select v-model="query.plateColor" clearable placeholder="全部" style="width: 130px" @change="search">
            <el-option label="全部" value="" />
            <el-option v-for="item in plateColorQueryOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="query.status" clearable placeholder="全部" style="width: 110px" @change="search">
            <el-option label="全部" value="" />
            <el-option label="正常" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

          <div class="vm-toolbar">
            <div class="vm-toolbar__left">
              <el-button v-permission="'vehicle:add'" type="primary" icon="el-icon-plus" @click="openVehicleCreate">新增</el-button>
              <el-button
                v-permission="'vehicle:delete'"
                type="danger"
                icon="el-icon-delete"
                :disabled="!selectedRows.length"
                @click="batchRemoveVehicles"
              >删除</el-button>
            </div>
            <div class="vm-toolbar__tools">
              <el-tooltip content="刷新" placement="top">
                <el-button icon="el-icon-refresh" @click="fetchList" />
              </el-tooltip>
              <el-popover placement="bottom-end" width="160" trigger="click">
                <el-checkbox
                  v-for="col in columns"
                  :key="col.key"
                  v-model="columnVisible[col.key]"
                  class="vm-col-check"
                >{{ col.label }}</el-checkbox>
                <el-tooltip slot="reference" content="列设置" placement="top">
                  <el-button icon="el-icon-s-grid" />
                </el-tooltip>
              </el-popover>
              <el-tooltip content="打印" placement="top">
                <el-button v-permission="'vehicle:export'" icon="el-icon-printer" :loading="exportLoading" @click="onPrint" />
              </el-tooltip>
              <el-dropdown v-permission="'vehicle:export'" trigger="click" @command="onExportCommand">
                <el-button icon="el-icon-upload2" :loading="exportLoading" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-permission="'vehicle:export'" command="csv">导出 CSV 文件</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <el-table
            v-loading="loading"
            :data="list"
            border
            stripe
            class="vm-table"
            @selection-change="onSelectionChange"
          >
            <el-table-column type="selection" width="60" align="center" />
            <el-table-column
              v-if="columnVisible.groupName"
              label="车辆分组"
              min-width="120"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">{{ row.groupName || '未分组' }}</template>
            </el-table-column>
            <el-table-column
              v-if="columnVisible.vehicleNo"
              prop="vehicleNo"
              label="车牌号"
              min-width="110"
              align="center"
            />
            <el-table-column v-if="columnVisible.plateColor" label="车牌颜色" width="90" align="center">
              <template slot-scope="{ row }">{{ plateColorLabel(row.plateColor) }}</template>
            </el-table-column>
            <el-table-column
              v-if="columnVisible.aliasName"
              prop="aliasName"
              label="别名"
              min-width="100"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              v-if="columnVisible.remarkMobile"
              prop="remarkMobile"
              label="备注手机号"
              min-width="110"
              align="center"
            />
            <el-table-column
              v-if="columnVisible.createTime"
              label="创建时间"
              min-width="170"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">{{ formatDateTime(row.createTime) }}</template>
            </el-table-column>
            <el-table-column v-if="columnVisible.status" label="状态" width="90" align="center">
              <template slot-scope="{ row }"><el-tag :type="vehicleEnabled(row) ? 'success' : 'info'" size="small">{{ vehicleEnabled(row) ? '正常' : '禁用' }}</el-tag></template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center" fixed="right">
              <template slot-scope="{ row }">
                <el-button v-permission="'vehicle:edit'" type="primary" size="mini" icon="el-icon-edit" @click="openVehicleEdit(row)" />
                <el-button v-permission="'vehicle:edit'" type="text" size="small" @click="changeStatus(row)">{{ vehicleEnabled(row) ? '禁用' : '启用' }}</el-button>
                <el-button v-permission="'vehicle:delete'" type="danger" size="mini" icon="el-icon-delete" @click="removeVehicle(row)" />
              </template>
            </el-table-column>
          </el-table>

          <div class="vm-pagination">
            <el-pagination
              background
              :current-page="page"
              :page-size="limit"
              :page-sizes="[10, 20, 50, 100]"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="changePageSize"
              @current-change="changePage"
            />
          </div>
        </div>
      </div>
    </div>

    <VehicleFormDialog
      :visible.sync="vehicleDialogVisible"
      :vehicle="editingVehicle"
      :group-tree="groupTree"
      :initial-group-id="selectedGroupId"
      @saved="onVehicleSaved"
    />
  </div>
</template>

<script>
import { authState, hasPermission } from '@/utils/auth'
import { defaultBusinessOptions, loadBusinessOptions, businessOptionLabel } from '@/utils/businessDictionaries'
import VehicleTeamTreeAside from '@/components/business/VehicleTeamTreeAside.vue'
import VehicleFormDialog from './VehicleFormDialog.vue'
import { getVehicleList, deleteVehicle, batchDeleteVehicles, updateVehicleStatus, isRequestSuccess } from './lingdongApi'

const columns = [
  { key: 'groupName', label: '车辆分组' },
  { key: 'vehicleNo', label: '车牌号' },
  { key: 'plateColor', label: '车牌颜色' },
  { key: 'aliasName', label: '别名' },
  { key: 'remark', label: '备注' },
  { key: 'remarkMobile', label: '备注手机号' },
  { key: 'searchLastTime', label: '最后查询时间' },
  { key: 'createTime', label: '创建时间' },
  { key: 'status', label: '状态' }
]

function csvCell(value) {
  let text = value == null ? '' : String(value)
  // 防止别名等自由文本被表格软件识别为公式。
  if (/^[=+@\-\t\r]/.test(text)) text = "'" + text
  return '"' + text.replace(/"/g, '""') + '"'
}

function escapeHtml(value) {
  return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

function formatDateTime(value) {
  if (value == null || value === '') return ''
  if (typeof value === 'string' && !/^\d+$/.test(value.trim())) return value.trim().replace('T', ' ').slice(0, 19)
  const date = new Date(Number(value))
  if (Number.isNaN(date.getTime())) return ''
  const pad = number => String(number).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

export default {
  name: 'VehicleManage',
  components: { VehicleTeamTreeAside, VehicleFormDialog },
  props: { embedded: { type: Boolean, default: false } },
  data() {
    const columnVisible = {}
    columns.forEach(column => { columnVisible[column.key] = true })
    return {
      loading: false, exportLoading: false,
      requestId: 0, dictionaryRequestId: 0, destroyed: false,
      list: [], selectedRows: [], groupTree: [], selectedGroupId: null,
      query: { vehicleNo: '', aliasName: '', plateColor: '', status: 1 },
      page: 1, limit: 10, total: 0, columns, columnVisible,
      vehicleDialogVisible: false, editingVehicle: {},
      plateColorOptions: [], plateColorLabels: {}
    }
  },
  computed: {
    managementAccount() { return authState.user },
    plateColorQueryOptions() {
      const active = this.plateColorOptions.map(item => ({ ...item }))
      const inactive = defaultBusinessOptions('vehicle_plate_color').filter(item => !active.some(option => Number(option.value) === Number(item.value)))
      return [...active, ...inactive].map(item => ({ ...item, label: this.plateColorLabel(item.value) }))
    }
  },
  watch: {
    managementAccount() {
      this.requestId++
      this.dictionaryRequestId++
      this.list = []
      this.total = 0
      this.selectedRows = []
      this.selectedGroupId = null
      this.groupTree = []
      this.vehicleDialogVisible = false
      this.editingVehicle = {}
      this.exportLoading = false
      this.loading = false
      if (this._printCleanup) this._printCleanup()
      this.plateColorOptions = []
      this.plateColorLabels = {}
      if (authState.user) { this.loadPlateColors(); this.fetchList() }
    }
  },
  created() { this.loadPlateColors(); this.fetchList() },
  beforeDestroy() {
    this.destroyed = true
    this.requestId++
    this.dictionaryRequestId++
    if (this._printCleanup) this._printCleanup()
    if (this._printFrame && this._printFrame.parentNode) this._printFrame.parentNode.removeChild(this._printFrame)
  },
  methods: {
    formatDateTime,
    vehicleEnabled(row) { return Number(row.status) === 1 && !Number(row.deleted) },
    async loadPlateColors() {
      const sequence = ++this.dictionaryRequestId
      const actor = authState.user
      this.plateColorOptions = []
      try {
        const options = await loadBusinessOptions('vehicle_plate_color')
        if (this.destroyed || sequence !== this.dictionaryRequestId || actor !== authState.user) return
        this.plateColorOptions = options
        this.plateColorLabels = { ...this.plateColorLabels, ...Object.fromEntries(options.map(item => [item.value, item.label])) }
      } catch (error) {
        if (!this.destroyed && sequence === this.dictionaryRequestId && actor === authState.user) this.$message.error(error.msg || error.message || '车牌颜色字典加载失败')
      }
    },
    plateColorLabel(value) {
      if (!this.plateColorOptions.some(item => Number(item.value) === Number(value)) && this.plateColorLabels[value]) return this.plateColorLabels[value] + '（已停用）'
      return businessOptionLabel('vehicle_plate_color', this.plateColorOptions, value)
    },
    onTeamTreeChange(tree) { this.groupTree = Array.isArray(tree) ? tree : [] },
    onTeamTreeSelect(payload) {
      if (!payload || payload.teamId == null) return
      this.selectedGroupId = payload.ungrouped ? 0 : payload.teamId
      this.page = 1
      this.fetchList()
    },
    clearGroupFilter() {
      this.selectedGroupId = null
      const aside = this.$refs.teamAsideRef
      if (aside) aside.clearSelection()
      this.page = 1
      this.fetchList()
    },
    handleGroupChanged() { this.fetchList(); this.$emit('changed') },
    async refreshAll() {
      const aside = this.$refs.teamAsideRef
      await Promise.all([aside ? aside.loadTeamTree() : Promise.resolve(), this.fetchList()])
    },
    buildParams(extra = {}) {
      const params = { page: this.page, limit: this.limit, ...extra }
      if (this.selectedGroupId !== null) params.groupId = this.selectedGroupId
      for (const key of ['vehicleNo', 'aliasName', 'plateColor', 'status']) {
        const value = this.query[key]
        if (value !== '' && value != null) params[key] = typeof value === 'string' ? value.trim() : value
      }
      return params
    },
    async fetchList() {
      const sequence = ++this.requestId
      const actor = authState.user
      const current = () => !this.destroyed && sequence === this.requestId && actor === authState.user
      this.loading = true
      try {
        const res = await getVehicleList(this.buildParams())
        if (!current()) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '车辆查询失败')
        this.list = (res.data && res.data.items) || []
        this.total = (res.data && Number(res.data.total)) || 0
        this.selectedRows = []
        const maxPage = Math.max(1, Math.ceil(this.total / this.limit))
        if (this.page > maxPage) { this.page = maxPage; return this.fetchList() }
      } catch (error) {
        if (!current()) return
        this.list = []
        this.total = 0
        this.$message.error(error.msg || error.message || '车辆查询失败')
      } finally { if (current()) this.loading = false }
    },
    onSelectionChange(rows) { this.selectedRows = rows || [] },
    search() { this.page = 1; return this.fetchList() },
    reset() {
      this.query = { vehicleNo: '', aliasName: '', plateColor: '', status: 1 }
      const aside = this.$refs.teamAsideRef
      if (aside) aside.onResetFilter()
      else this.clearGroupFilter()
    },
    changePageSize(size) { this.limit = size; this.page = 1; this.fetchList() },
    changePage(page) { this.page = page; this.fetchList() },
    openVehicleCreate() { this.editingVehicle = {}; this.vehicleDialogVisible = true },
    openVehicleEdit(row) { this.editingVehicle = { ...row }; this.vehicleDialogVisible = true },
    onVehicleSaved() { this.refreshAll(); this.$emit('changed') },
    async removeVehicle(row) {
      const actor = authState.user
      try {
        await this.$confirm('确认删除该车辆？', '提示', { type: 'warning' })
        if (this.destroyed || actor !== authState.user) return
        const res = await deleteVehicle(row.id)
        if (this.destroyed || actor !== authState.user) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '删除失败')
        this.$message.success('删除成功')
        await this.refreshAll()
        this.$emit('changed')
      } catch (error) { if (error && error !== 'cancel' && error !== 'close' && !this.destroyed && actor === authState.user) this.$message.error(error.msg || error.message || '删除失败') }
    },
    async batchRemoveVehicles() {
      const ids = this.selectedRows.map(row => row.id)
      if (!ids.length) return this.$message.warning('请先选择要删除的车辆')
      const actor = authState.user
      try {
        await this.$confirm(`确认删除选中的 ${ids.length} 辆车？`, '提示', { type: 'warning' })
        if (this.destroyed || actor !== authState.user) return
        const res = await batchDeleteVehicles(ids)
        if (this.destroyed || actor !== authState.user) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '删除失败')
        this.$message.success('删除成功')
        await this.refreshAll()
        this.$emit('changed')
      } catch (error) { if (error && error !== 'cancel' && error !== 'close' && !this.destroyed && actor === authState.user) this.$message.error(error.msg || error.message || '删除失败') }
    },
    async changeStatus(row) {
      const enabled = this.vehicleEnabled(row) ? 0 : 1
      const action = enabled ? '启用' : '禁用'
      const actor = authState.user
      try {
        await this.$confirm(`确认${action}车辆“${row.vehicleNo}”吗？`, '提示', { type: 'warning' })
        if (this.destroyed || actor !== authState.user) return
        const res = await updateVehicleStatus(row.id, enabled)
        if (this.destroyed || actor !== authState.user) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || `${action}失败`)
        this.$message.success(`车辆已${action}`)
        await this.refreshAll()
        this.$emit('changed')
      } catch (error) { if (error && error !== 'cancel' && error !== 'close' && !this.destroyed && actor === authState.user) this.$message.error(error.msg || error.message || `${action}失败`) }
    },
    visibleColumns() { return this.columns.filter(column => this.columnVisible[column.key]) },
    exportCellValue(row, column) {
      if (column.key === 'groupName') return row.groupName || '未分组'
      if (column.key === 'plateColor') return this.plateColorLabel(row.plateColor)
      if (column.key === 'createTime' || column.key === 'searchLastTime') return formatDateTime(row[column.key])
      if (column.key === 'status') return this.vehicleEnabled(row) ? '正常' : '禁用'
      return row[column.key]
    },
    async fetchAllRows() {
      const actor = authState.user
      const params = this.buildParams({ page: 1, limit: 100 })
      const rows = []
      let total = 0
      do {
        const res = await getVehicleList({ ...params })
        if (this.destroyed || actor !== authState.user) throw new Error('账号已变化，请重新操作')
        if (!isRequestSuccess(res) || !res.data || !Array.isArray(res.data.items)) throw new Error((res && res.msg) || '获取导出数据失败')
        total = Number(res.data.total) || 0
        if (!res.data.items.length && rows.length < total) throw new Error('车辆数据已变化，请刷新后重试')
        rows.push(...res.data.items)
        params.page++
      } while (rows.length < total)
      return rows
    },
    onExportCommand(command) { if (command === 'csv') return this.downloadVehicles() },
    async downloadVehicles() {
      if (!hasPermission('vehicle:export')) return this.$message.warning('没有车辆导出权限')
      if (this.exportLoading) return
      const columns = this.visibleColumns()
      if (!columns.length) return this.$message.warning('请至少显示一列')
      const actor = authState.user
      this.exportLoading = true
      try {
        const rows = await this.fetchAllRows()
        if (this.destroyed || actor !== authState.user) return
        if (!rows.length) return this.$message.warning('暂无数据可导出')
        if (!hasPermission('vehicle:export')) return this.$message.warning('没有车辆导出权限')
        const csv = columns.map(column => csvCell(column.label)).join(',') + '\n' + rows.map(row => columns.map(column => csvCell(this.exportCellValue(row, column))).join(',')).join('\n')
        const url = URL.createObjectURL(new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' }))
        const link = document.createElement('a')
        link.href = url
        link.download = `车辆管理_${Date.now()}.csv`
        link.click()
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (error) { if (!this.destroyed && actor === authState.user) this.$message.error(error.msg || error.message || '获取导出数据失败') }
      finally { if (!this.destroyed && actor === authState.user) this.exportLoading = false }
    },
    async onPrint() {
      if (!hasPermission('vehicle:export')) return this.$message.warning('没有车辆导出权限')
      if (this.exportLoading) return
      const columns = this.visibleColumns()
      if (!columns.length) return this.$message.warning('请至少显示一列')
      const actor = authState.user
      this.exportLoading = true
      try {
        const rows = await this.fetchAllRows()
        if (this.destroyed || actor !== authState.user) return
        if (!rows.length) return this.$message.warning('暂无数据可打印')
        if (!hasPermission('vehicle:export')) return this.$message.warning('没有车辆导出权限')
        const thead = columns.map(column => `<th>${escapeHtml(column.label)}</th>`).join('')
        const tbody = rows.map(row => `<tr>${columns.map(column => `<td>${escapeHtml(this.exportCellValue(row, column))}</td>`).join('')}</tr>`).join('')
        const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>车辆管理</title><style>body{font-family:Arial,sans-serif;padding:16px;}h2{text-align:center;margin:0 0 16px;font-size:18px;}table{width:100%;border-collapse:collapse;}th,td{border:1px solid #333;padding:8px;text-align:center;font-size:14px;}th{background:#f2f2f2;}</style></head><body><h2>车辆管理</h2><table><thead><tr>${thead}</tr></thead><tbody>${tbody}</tbody></table></body></html>`
        if (this._printCleanup) this._printCleanup()
        if (!this._printFrame) {
          this._printFrame = document.createElement('iframe')
          this._printFrame.className = 'vm-print-frame'
          this._printFrame.setAttribute('aria-hidden', 'true')
          document.body.appendChild(this._printFrame)
        }
        const win = this._printFrame.contentWindow
        const doc = win.document
        doc.open(); doc.write(html); doc.close()
        const media = win.matchMedia('print')
        const cleanup = () => {
          clearTimeout(timer)
          media.removeEventListener('change', onPrintEnd)
          win.onafterprint = null
          doc.open(); doc.write(''); doc.close()
          this._printCleanup = null
        }
        const onPrintEnd = event => { if (!event.matches) cleanup() }
        const timer = setTimeout(() => { if (!this.destroyed && actor === authState.user) win.print(); else cleanup() }, 150)
        this._printCleanup = cleanup
        win.onafterprint = cleanup
        media.addEventListener('change', onPrintEnd)
        win.focus()
      } catch (error) { if (!this.destroyed && actor === authState.user) this.$message.error(error.msg || error.message || '获取打印数据失败') }
      finally { if (!this.destroyed && actor === authState.user) this.exportLoading = false }
    }
  }
}
</script>

<style scoped>
.vm-page {
  width: 100%;
  min-height: 100%;
  padding: 1rem;
  box-sizing: border-box;
  background: #f5f7fa;
}

.vm-page--embedded { padding: 0.75rem; }

.vm-layout {
  display: flex;
  align-items: stretch;
  gap: 0.75rem;
  min-height: calc(100vh - 8rem);
}

.vm-main {
  flex: 1;
  min-width: 0;
}

.vm-card {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  padding: 0.75rem;
  box-sizing: border-box;
}

.vm-query {
  margin-bottom: 0.5rem;
}

.vm-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.vm-toolbar__left {
  display: flex;
  gap: 0.5rem;
}

.vm-toolbar__tools {
  display: flex;
  gap: 0.25rem;
}

.vm-toolbar__tools .el-button {
  padding: 0.5rem;
}

.vm-col-check {
  display: block;
  margin: 0.35rem 0;
}

.vm-table {
  width: 100%;
}

.vm-table >>> .el-table__header-wrapper th {
  background: #f2f2f2 !important;
  color: #333;
  font-weight: 600;
}

.vm-pagination {
  padding: 0.75rem 0.25rem 0.25rem;
}

</style>

<style>
.vm-print-frame {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 0;
  height: 0;
  border: 0;
  visibility: hidden;
}
</style>
